export const PROGRAMIZ = {
  border: '#E4E7EB',
  headerBg: '#F8F9FA',
  bodyBg: '#FFFFFF',
  tabActive: '#2563EB',
  runBg: '#2563EB',
  runHover: '#1D4ED8',
  text: '#1F2937',
  muted: '#6B7280',
};

export const programizRunButtonSx = {
  bgcolor: PROGRAMIZ.runBg,
  color: '#fff',
  fontWeight: 600,
  fontSize: 14,
  textTransform: 'none',
  px: 2,
  py: 0.75,
  borderRadius: 0.5,
  boxShadow: 'none',
  flexShrink: 0,
  '&:hover': { bgcolor: PROGRAMIZ.runHover, boxShadow: 'none' },
};

export const programizSecondaryButtonSx = {
  color: PROGRAMIZ.text,
  borderColor: PROGRAMIZ.border,
  fontWeight: 500,
  fontSize: 13,
  textTransform: 'none',
  px: 1.5,
  py: 0.5,
  borderRadius: 0.5,
  flexShrink: 0,
  '&:hover': { borderColor: PROGRAMIZ.muted, bgcolor: 'rgba(0,0,0,0.03)' },
};
